import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE_URL } from "@/data/site";

const setAttr = (sel, attr, val) => {
  const el = document.querySelector(sel);
  if (el && val) el.setAttribute(attr, val);
};

export const usePageMeta = (title, description) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = `${SITE_URL}${pathname}`;
    document.title = title;
    setAttr('meta[name="description"]', "content", description);
    setAttr('meta[property="og:title"]', "content", title);
    setAttr('meta[name="twitter:title"]', "content", title);
    setAttr('meta[property="og:description"]', "content", description);
    setAttr('meta[name="twitter:description"]', "content", description);
    setAttr('meta[property="og:url"]', "content", url);
    setAttr('link[rel="canonical"]', "href", url);
    // Only the Emergent preview and local dev are hidden from search; every live domain is indexable.
    const host = window.location.hostname;
    const prod = !host.endsWith("preview.emergentagent.com") && host !== "localhost" && host !== "127.0.0.1";
    setAttr('meta[name="robots"]', "content", prod && !pathname.startsWith("/admin") ? "index, follow, max-image-preview:large, max-snippet:-1" : "noindex, nofollow");
  }, [title, description, pathname]);
};

export const SectionHead = ({ eyebrow, title, children, light = false, className = "" }) => (
  <div className={className}>
    {eyebrow && <p className={`eyebrow ${light ? "!text-[#f0b3b7]" : ""}`}>{eyebrow}</p>}
    <h2 className={`mt-4 font-display text-4xl font-semibold leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl ${light ? "text-white" : "text-[#14263D]"}`}>{title}</h2>
    {children && <div className={`mt-6 max-w-2xl text-base leading-relaxed md:text-lg ${light ? "text-white/85" : "text-[#5F6B76]"}`}>{children}</div>}
  </div>
);
